angular.module('storefrontApp')
    .component('rsFirstVisit', {
        templateUrl: 'themes/assets/js/common-components/rsFirstVisit.component.liquid',
        controller: [function () {
            const ctrl = this;

            this.$onInit = function () {
                ctrl.isFirstTime = false;
            };

            this.closePopUp = function () {
                ctrl.isFirstTime = false;
            };
        }],
    });
